export default class MobileDeviceMenu {
    constructor(props) {
        this.container = props.container;
        this.logo = props.logo;
        this.menu = props.menu;
        this.after = props.after;
        this.active_class = props.active_class ? props.active_class : '.active';
        this.special_class = props.special_class ? props.special_class : '';

        $(window).on('load', () => {
            let $html = this.generateTemplate();

            //$('html').addClass('mdm__open');
            $(this.container).addClass('mdm__wrapper');
            $(this.container).html($html);
            this.addBlocksAfter();
        });

        $('html').addClass('mdm__closed');//default is closed

        $(document).on('click', '.mdm__backdrop, .mdm__open .c-hamburger, .mdm__close', () => {
            $('html').removeClass('mdm__open').addClass('mdm__closed');
            $('.mdm__close').addClass('d-none');
        }).on('click', '.mdm__closed [data-mdm-target]', function() {
            $('html').removeClass('mdm__closed').addClass('mdm__open');
            $('.mdm__close').removeClass('d-none');

            return false;
        });
    }

    getItemClass($item) {
        let list = this.active_class;
        let classList = ``;
        let className = ``;

        for(let index in list) {
            if(list.hasOwnProperty(index) && $item.is(this.special_class)) {
                classList = `${this.special_class.split('.').join("")}`;
            }

            if(list.hasOwnProperty(index) && $item.is(list[index])) {
                className = `class="active ${classList}"`;
                break;
            }else {
                className = `class="${classList}"`
            }
        }

        return className;
    }

    generateNav() {
        let menuHTML = `<ul class="mdm__nav">`;
        let mobileMenuHtml = '';

        this.menu.forEach((selector) => {
            $(selector).find('li').each((index, el) => {
                let className = this.getItemClass($(el));
                let link = $(el).find('a').attr('href');
                let text = $(el).find('a').text().trim();

                if(selector === '#menu-mobile-menu-left'){
                    mobileMenuHtml +=
                        `<li class="category-item">
                            <a href="${link}">${text}
                                <span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>
                            </a>
                        </li>`;
                }else {
                    menuHTML += `<li ${className}><a href="${link}">${text}</a></li>`;
                }
            });
        });

        menuHTML += `</ul>`;

        var $html = $('<div />',{ html: menuHTML });
        $html.find('.special-item').after(mobileMenuHtml);
        menuHTML = $html.html();

        return menuHTML;
    }

    generateLogo() {
        let $logo = $(this.logo);
        let indexUrl = $logo.attr('href');
        let $img = $(this.logo).find('img');
        let url = $img.attr('src');
        let alt = $img.attr('alt');

        return `<div class="mdm__logo"><a href="${indexUrl}"><img src="${url}" alt="${alt}"></a></div>`;
    }

    generatePaddingTop() {
        let $wpAdminBar = $('#wpadminbar');
        let paddingHTML = ``;

        if($wpAdminBar) {
            let paddingTop = $('#wpadminbar').height();

            //paddingHTML = `<div class="mdm__padding" style="height: ${paddingTop}px"></div>`;
        }

        return paddingHTML;
    }

    addBlocksAfter() {
        if(this.after.length) {
            $('.mdm__scroll').append('<div class="mdm__blocks"></div>');
        }

        this.after.forEach((selector) => {
            let $block = $(selector).clone();
            let id = $block.attr('id');

            $block.removeAttr('id').removeAttr('class').addClass(id + ' item');
            $('.mdm__blocks').append($block);
        });
    }

    generateTemplate() {
        let menuHTML = this.generateNav();
        let logoHTML = '';//this.generateLogo();
        let paddingTopHTML = this.generatePaddingTop();

        return `
            <div class="mdm__backdrop"></div>
            <div class="mdm__container">
                <div class="mdm__scroll">
                    ${paddingTopHTML}
                    <div class="mdm__header">${logoHTML}</div>
                    <div class="mdm__list">
                        ${menuHTML}
                        <div class="mdm__close d-none">
                            <span class="brand-icon ill-angle-right"><span class="path1"></span><span class="path2"></span></span>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}